import React from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { useTranslation } from "react-i18next";

import { DataStructure } from "@/components/StaticTable";
import {
  Operator,
  OPERATORS,
} from "@/components/StaticTable/Filters/operators";

interface OperateurSelectProps<T> {
  selectedcolumn: DataStructure<T>;
  selectedFiltreKey: String | null;
  setSelectedOperator: React.Dispatch<React.SetStateAction<Operator | null>>;
  selectedOperator: Operator | null;
}

export function OperateurSelect<T>({
  selectedcolumn,
  selectedFiltreKey,
  setSelectedOperator,
  selectedOperator,
}: OperateurSelectProps<T>) {
  const { t } = useTranslation();

  const handleChange = (event: any) => {
    let operateur = OPERATORS.find((op) => op.value === event?.target?.value);
    if (operateur) setSelectedOperator(operateur);
  };

  const getOperators = (): Operator[] => {
    return OPERATORS.filter((operator) => {
      if (!selectedcolumn || !selectedFiltreKey) return false;

      const filters = Array.isArray(selectedcolumn.filter)
        ? selectedcolumn.filter
        : [selectedcolumn.filter];
      // @ts-ignore
      const matchingFilter = filters.find((f) => f.key === selectedFiltreKey);

      if (Array.isArray(selectedcolumn?.filter)) {
        /** colonne avec multi filtres */
        let filtreRowType = selectedcolumn?.filter!.find(
          (filtre) => filtre.key === selectedFiltreKey
        )?.rowType;
        const isTypeCompatible =
          filtreRowType && operator.type.includes(filtreRowType);

        if (operator.value === "IS_NULL")
          return isTypeCompatible && matchingFilter.nullable;
        return isTypeCompatible;
      } else {
        let filtreRowType = selectedcolumn?.filter?.rowType;

        const isTypeCompatible =
          filtreRowType && operator.type.includes(filtreRowType);

        if (operator.value === "IS_NULL")
          return isTypeCompatible && matchingFilter.nullable;
        return isTypeCompatible;
      }
    });
  };

  return (
    <FormControl variant="filled" fullWidth disabled={!selectedFiltreKey}>
      <InputLabel>{t("common.dmri.filter.operator")}</InputLabel>
      <Select onChange={handleChange} value={selectedOperator?.value}>
        {getOperators().map((item, index) => {
          return (
            <MenuItem key={index} value={item.value}>
              {t(item.label)}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

export default OperateurSelect;
